module.exports = __webpack_public_path__ + "assets/img/ps-2.c0617f6d.png";